import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import ClearIcon from "@mui/icons-material/Clear";

import Styled from "../Styled";

const SearchResults = ({ results, onCloseSearchBoard, loading, error }) => {
	// console.log("from searchResultsComponent::\n");
	// console.log(results);
	return results?.length ? (
		<Styled.SearchBoard>
			<Styled.SearchUtilsCont>
				<Box sx={{ alignSelf: "start", width: "100%" }}>
					<Box
						sx={{ p: 1, cursor: "pointer" }}
						component="span"
						onClick={onCloseSearchBoard}
						onKeyDown={e => {
							console.log("key prissed");
							if (e.key !== "Escape") return;
							onCloseSearchBoard();
						}}
						tabIndex={-1}
					>
						<ClearIcon />
					</Box>
				</Box>
				<Box
					sx={{
						display: "flex",
						width: "100%",
						alignItems: "stretch",
						minHeight: 400
					}}
				>
					<Styled.SearchRightPane>
						<p>Search Results...</p>
						<Stack
							spacing={2}
							divider={
								<hr style={{ color: "#fff", backgroundColor: "#fff" }} />
							}
						>
							{results?.map((result, idx) => {
								return (
									<Styled.SearchResult
										key={idx}
										component={Link}
										href={`/detail/${result?.bidId}?productId=${result?.productId}`}
									>
										<Styled.SearchResultImgBox>
											<img
												src={result?.image}
												alt={result?.name}
												style={{ width: "100%", height: "100%" }}
												className="search-result-item"
											/>
										</Styled.SearchResultImgBox>
										<Styled.SearchResultContainer elevation={0}>
											<Styled.SearchResultTitle>
												{result?.name}
											</Styled.SearchResultTitle>
											<Styled.SearchResultSubInfoContainer
												direction="row"
												divider={<Divider orientation="vertical" flexItem />}
												spacing={2}
											>
												<span>Model: {result?.brand}</span>
												<span>Category: {result?.category}</span>
												<span>Bids @: {result?.bidPrice}/=</span>
											</Styled.SearchResultSubInfoContainer>
											<Styled.SearchResultDesc>
												{result?.cat_desc}
											</Styled.SearchResultDesc>
										</Styled.SearchResultContainer>
									</Styled.SearchResult>
								);
							})}
						</Stack>
					</Styled.SearchRightPane>
				</Box>
			</Styled.SearchUtilsCont>
		</Styled.SearchBoard>
	) : loading ? null : (
		<Styled.SearchBoard>
			<Styled.SearchUtilsCont>
				<Box sx={{ alignSelf: "start", width: "100%" }}>
					<Box
						sx={{ p: 1, cursor: "pointer" }}
						component="span"
						onClick={onCloseSearchBoard}
					>
						<ClearIcon />
					</Box>
				</Box>
				<Box sx={{ alignSelf: "start", width: "100%" }}>
					<Typography variant="h5">
						{!error?.length ? "No Search results found :(" : error[0]?.msg}
					</Typography>
				</Box>
			</Styled.SearchUtilsCont>
		</Styled.SearchBoard>
	);
};

export default React.memo(SearchResults);
